import type { GeoCountry, HostedEventPlace, Location } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { emptyShow, type ShowDraft, type ShowErrors, type ShowField } from "../../core/primitives/hosted-event";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../core/primitives/load-status";
import {
  EMPTY_LOCATION,
  type LocationDraft,
  type LocationErrors,
  type LocationField,
} from "../../core/primitives/location-form";
import type { GeoRegionList } from "../../core/repositories/countries-repository";

/** The form of a new show, or of one the shop already hosts. */
export class EventEditState {
  readonly creating = new Rx(true);
  /** Loading the show to edit; a new one is loaded from the start. */
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly draft = new Rx<ShowDraft>(emptyShow("UTC"));
  readonly errors = new Rx<ShowErrors>({});
  /** The building a new show names, when it is not one of the shop's own. */
  readonly venueDraft = new Rx<LocationDraft>(EMPTY_LOCATION);
  readonly venueErrors = new Rx<LocationErrors>({});
  readonly regions = new Rx<GeoRegionList>([]);
  readonly countries = new RxList<GeoCountry>();
  readonly countriesStatus = new Rx<LoadStatus>(idleLoad);
  /** The shop's own premises a new show may be held at. */
  readonly locations = new RxList<Location>();
  /** A saved show's venue, which no longer changes. */
  readonly place = new Rx<HostedEventPlace | null>(null);
  readonly zones = new Rx<readonly string[]>([]);
  readonly form = new Rx<FormStatus>(idleForm);

  /** When the host cancelled the show; its form is read-only then. */
  readonly cancelledAt = new Rx<Date | null>(null);
}

export abstract class EventEditActions {
  abstract setField(field: ShowField, value: string): void;
  abstract setVenueField(field: LocationField, value: string): void;
  abstract save(): Promise<void>;
  abstract cancel(): void;
}
